import { defineStore } from 'pinia';
import { useApi } from '../services/api';

export const useUserStore = defineStore('user', {
  state: () => ({
    email: '',
    email_verified: false,
    family_name: '',
    given_name: '',
    name: '',
    preferred_username: '',
    id: '',
    account_id: '',
  }),
  actions: {
    async fetch(): Promise<void> {
      const api = useApi();

      const data = await api.auth.getUserInfo();

      if (!data) {
        return;
      }

      this.email = data.email;
      this.email_verified = data.email_verified;
      this.family_name = data.family_name;
      this.given_name = data.given_name;
      this.name = data.name;
      this.preferred_username = data.preferred_username;
      this.id = data.sub;
      this.account_id = data.account_id;
    },
    async clear(): Promise<void> {
      this.$reset();
    },
  },
});
